import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type SettingsPageAttackListSenderEditViewSettingFragment = { __typename?: 'AttackListSenderSetting', id: string, isEnabled: boolean, title: string, body: string, selections: Array<string>, planner: { __typename?: 'Planner', id: string }, entrance: { __typename?: 'Entrance', guid: string }, rule: { __typename?: 'AttackListSenderSettingRule', partner: Types.AttackListSenderSettingRuleExistence, child: Types.AttackListSenderSettingRuleExistence, gender: Types.AttackListSenderSettingRuleGender, shouldSendIfSameCorporationApproached: boolean, savingRange?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null, annualIncomeRange?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null, familyAnnualIncomeRange?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null, ageOfFirstChildRange?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null, age?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null, investmentRange?: { __typename?: 'AttackListSenderSettingRuleRange', min?: number | null, max?: number | null } | null } };

export type SettingsPageAttackListSenderEditViewPlannerFragment = { __typename?: 'Planner', id: string, name: string };

export type SettingsPageAttackListSenderEditViewEntranceFragment = { __typename?: 'Entrance', guid: string, name: string };

export const SettingsPageAttackListSenderEditViewSettingFragmentDoc = gql`
    fragment SettingsPageAttackListSenderEditViewSetting on AttackListSenderSetting {
  id
  planner {
    id
  }
  entrance {
    guid
  }
  isEnabled
  title
  body
  selections
  rule {
    savingRange {
      min
      max
    }
    annualIncomeRange {
      min
      max
    }
    familyAnnualIncomeRange {
      min
      max
    }
    partner
    child
    ageOfFirstChildRange {
      min
      max
    }
    gender
    age {
      min
      max
    }
    investmentRange {
      min
      max
    }
    shouldSendIfSameCorporationApproached
  }
}
    `;
export const SettingsPageAttackListSenderEditViewPlannerFragmentDoc = gql`
    fragment SettingsPageAttackListSenderEditViewPlanner on Planner {
  id
  name
}
    `;
export const SettingsPageAttackListSenderEditViewEntranceFragmentDoc = gql`
    fragment SettingsPageAttackListSenderEditViewEntrance on Entrance {
  guid
  name
}
    `;